<template>
	<div class="app">
		<router-view />
	</div>
</template>

<script setup>
import { onKeyStroke } from '@vueuse/core';
import { stacks } from 'store';

onKeyStroke(
	`Escape`,
	e => {
		e.preventDefault();

		let highestPriority = 0;
		for( const stack of stacks ) {
			if( stack.priority < highestPriority ) {
				continue;
			}

			if( stack.removed ) {
				continue;
			}

			highestPriority = stack.priority;
		}

		for( let i = 0; i < stacks.length; i++ ) {
			const stack = stacks[i];
			if( stack.priority < highestPriority ) {
				continue;
			}

			if( stack.removed ) {
				continue;
			}

			stack.close();
			stack.removed = true;
			break;
		}
	}
);
</script>
